export default "__VITE_ASSET__CH_nh6P4__"